import apiService from './apiService';

// ================= PLANT SAFETY WORK PERMIT APIs =================
export const createPlantSafetyWorkPermit = async (payload: any) => {
  const response = await apiService.post('/plant-safety-work-permits', payload);
  return response.data;
};

export const getPlantSafetyWorkPermitById = async (id: string | number) => {
  const response = await apiService.get(`/plant-safety-work-permits/${id}`);
  return response.data;
};

export const updatePlantSafetyWorkPermit = async (id: string | number, payload: any) => {
  const response = await apiService.put(`/plant-safety-work-permits/${id}`, payload);
  return response.data;
};

export const deletePlantSafetyWorkPermit = async (id: string | number) => {
  const response = await apiService.delete(`/plant-safety-work-permits/${id}`);
  return response.data;
};

//  UPDATED: accepts page and search params
export const getPlantSafetyWorkPermits = async (page = 1, search = '') => {
  try {
    const params = new URLSearchParams({
      per_page: '1000',
      page: String(page),
    });

    //  correct query format: filter[search]
    if (search) params.append('filter[search]', search);

    const response = await apiService.get(`/plant-safety-work-permits?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching Plant Safety Work Permits:', error);
    throw error;
  }
};

// ================= PSWP SIGNATURE APIs =================
export const createPSWPSignature = async (payload: any) => {
  const response = await apiService.post('/pswp-signatures', payload);
  return response.data;
};

export const getPSWPSignatureById = async (id: string | number) => {
  const response = await apiService.get(`/pswp-signatures/${id}`);
  return response.data;
};

// Get signature by work permit ID
export const getPSWPSignatureByWorkPermitId = async (workPermitId: string | number) => {
  try {
    const params = new URLSearchParams({
      'filter[plant_safety_work_permit_id]': String(workPermitId),
    });
    const response = await apiService.get(`/pswp-signatures?${params.toString()}`);
    const responseData = response.data;
    const signatureData = Array.isArray(responseData) ? responseData : (responseData?.data ?? responseData);

    if (Array.isArray(signatureData)) {
      const matchingSignature = signatureData.find((signature: any) => {
        const permitId = signature?.plant_safety_work_permit_id ?? signature?.plant_safety_work_permit?.id;
        return String(permitId) === String(workPermitId);
      });

      // A correctly filtered resource may omit the foreign key from its response.
      return matchingSignature ?? (signatureData.length === 1 ? signatureData[0] : null);
    }

    return signatureData;
  } catch (error) {
    console.error('Error fetching PSWP Signature by work permit ID:', error);
    throw error;
  }
};

export const updatePSWPSignature = async (id: string | number, payload: any) => {
  const response = await apiService.put(`/pswp-signatures/${id}`, payload);
  return response.data;
};

// ================= PSWP RESPONSIBLE PERSONS APIs =================
export const getPSWPResponsiblePersons = async () => {
  try {
    const response = await apiService.get('/users?filter[user_type_id]=14');
    return response.data;
  } catch (error) {
    console.error('Error fetching PSWP Responsible Persons:', error);
    throw error;
  }
};

// ================= PLANT CODES APIs =================
export const getPlantCodes = async () => {
  try {
    const response = await apiService.get('/plantcodes');
    return response.data;
  } catch (error) {
    console.error('Error fetching Plant Codes:', error);
    throw error;
  }
};

// ================= PLANT REQUIRING ISOLATION APIs =================
export const getPlantRequiringIsolation = async () => {
  try {
    const response = await apiService.get('/plant-requiring-isolations');
    return response.data;
  } catch (error) {
    console.error('Error fetching Plant Requiring Isolation:', error);
    throw error;
  }
};

// ================= APPOINTED OPERATORS APIs =================
export const getAppointedOperators = async () => {
  try {
    const response = await apiService.get('/users?filter[user_type_id]=4');
    return response.data;
  } catch (error) {
    console.error('Error fetching Appointed Operators:', error);
    throw error;
  }
};

export const getAppointedPersonsLV = async () => {
  try {
    const response = await apiService.get('/users?filter[user_type_id]=15');
    return response.data;
  } catch (error) {
    console.error('Error fetching Appointed Operators:', error);
    throw error;
  }
};

// Backward compatibility alias
export const getAppointedOPerators = getAppointedOperators;

export const notifyIsolationInstructions = async (id: number | string, payload: { user_ids: number[] }) => {
  try {
    const response = await apiService.post(`/lv-work-permits/${id}/notify-isolation`, payload);
    return response.data;
  } catch (error) {
    console.error('Error notifying isolation:', error);
    throw error;
  }
};
export const getPlantSafetyWorkPermitDownload = async (id: string | number) => {
  try {
    const response = await apiService.get(`plant-safety-work-permits/${id}/download`, {
      responseType: 'blob',
    });
    return response.data; // Blob
  } catch (error) {
    console.error('Error downloading plant-safety-work-permit:', error);
    throw error;
  }
};

export const getSanctionForTestDownload = async (id: string | number) => {
  try {
    const response = await apiService.get(`/plant-safety-work-permits/${id}/download-sft`, {
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    console.error('Error downloading sanction for test:', error);
    throw error;
  }
};
